/**
 * Created by jv on 19/01/2017.
 */
const utils = require("Sources/utils/utils");

var collapse = {};

(function(Collapsible)
{
  Collapsible.makeCollapsible = function(options)
  {
    var collapseWrapper = $(options.selector);

    var triggerEl = collapseWrapper.find("[data-trigger]").first();
    var collapseEl = collapseWrapper.find("[data-target]").first();

    if(!collapseEl.hasClass("collapse"))
    {
      collapseEl.addClass("collapse");

      if(options.expanded && !collapseEl.hasClass("in"))
      {
        collapseEl.addClass("in");
      }
    }

    collapseEl.collapse({
      toggle: options.expanded || false
    });

    triggerEl.on("click", function()
    {
      $(this).nextAll(".collapse").collapse("toggle");
    });

    collapseEl.on("show.bs.collapse", function(e)
    {
      if($(this).is(e.target)) // For some reason the bootstrap datepicker triggers these if it's inside a collapsible element :s
      {
        triggerEl.addClass("open");

        if(utils.isFunction(options.onExpand))
        {
          options.onExpand($(this), e);
        }
      }
    });

    collapseEl.on("hide.bs.collapse", function(e)
    {
      if($(this).is(e.target)) // For some reason the bootstrap datepicker triggers these if it's inside a collapsible element :s
      {
        triggerEl.removeClass("open");

        if(utils.isFunction(options.onCollapse))
        {
          options.onCollapse($(this), e);
        }
      }
    });

    if(utils.isFunction(options.afterExpand))
    {
      collapseEl.on("shown.bs.collapse", options.afterExpand);
    }

    if(utils.isFunction(options.afterCollapse))
    {
      collapseEl.on("hidden.bs.collapse", options.afterCollapse);
    }
  };

  // Collapsible.makeCollapsible = function(options)
  // {
  //   $(options.selector).on("click", function(e)
  //   {
  //     var thisEl = $(this);
  //
  //     var parent = thisEl.attr("data-parent");
  //     var target = thisEl.attr("data-target");
  //
  //     var targetEl = $(target);
  //
  //     if(targetEl.hasClass("collapsing"))
  //     {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return;
  //     }
  //
  //     if(targetEl.hasClass("in"))
  //     {
  //       if(utils.isFunction(options.onCollapse))
  //       {
  //         options.onCollapse(true);
  //       }
  //
  //       Collapsible.collapse(targetEl, "height");
  //     }
  //     else
  //     {
  //       if(utils.isFunction(options.onCollapse))
  //       {
  //         options.onCollapse(false);
  //       }
  //
  //       Collapsible.expand(targetEl, "height");
  //     }
  //   });
  // };
  //
  // Collapsible.collapse = function(element, dimension)
  // {
  //   element["height"](element[dimension]())[0].offsetHeight;
  //
  //   element.removeClass("collapse in").addClass("collapsing");
  //   element.css(dimension, "0px");
  //
  //   setTimeout(function()
  //   {
  //     element.removeClass("collapsing").addClass("collapse");
  //   }, 350);
  // };
  //
  // Collapsible.expand = function(element, dimension)
  // {
  //   var scrollSize = "scroll" + dimension.charAt(0).toUpperCase() + dimension.slice(1);
  //
  //   element.removeClass("collapse").addClass("collapsing")["height"](0);
  //   element["height"](element[0][scrollSize]);
  //
  //   setTimeout(function()
  //   {
  //     element.removeClass("collapsing").addClass("collapse in").css("height", "");
  //   }, 350);
  // };
}(collapse));

module.exports = collapse;



// WEBPACK FOOTER //
// ./app/js/components/collapse.js